import { ETableColumnAccessor } from './binary';
export const TABLE_COLUMNS_DESCRIPTIONS = {
    [ETableColumnAccessor.Ancestry]: 'Ancestry',
    [ETableColumnAccessor.Variants]: 'Variant ID: Chromosome-GRCh38 coordinate (position)-reference allele-alternate allele',
    [ETableColumnAccessor.CollapsingModelName]: 'Collapsing model used to define qualifying variants. See global filters for model definitions',
    [ETableColumnAccessor.PValue]: 'P value from Fisher\'s Exact Test',
    [ETableColumnAccessor.Samples]: 'Number of participants',
    [ETableColumnAccessor.QVCases]: 'Number of cases with a qualifying variant',
    [ETableColumnAccessor.CaseFrequency]: 'Percentage of cases with a qualifying variant',
    [ETableColumnAccessor.QVControls]: 'Number of controls with a qualifying variant',
    [ETableColumnAccessor.ControlFrequency]: 'Percentage of controls with a qualifying variant',
    [ETableColumnAccessor.OddsRatio]: 'Odds ratio',
    [ETableColumnAccessor.OddsRatioLCI]: 'Lower limit of the 95% confidence interval for the odds ratio',
    [ETableColumnAccessor.OddsRatioUCI]: 'Upper limit of the 95% confidence interval for the odds ratio',
};
